import classNames from "classnames";
import React from "react";
import { Link } from "react-router-dom";
import styles from "../styles/NewsContainer.module.scss";
const NewsContainer = ({ title }) => {
  return (
    <div
      className={classNames(
        styles.newsContainer,
        title === "Bridging Loans"
          ? styles.bLoans
          : title === "Development Finance"
          ? styles.dFinance
          : title === "Stop Repossessions"
          ? styles.sRepo
          : title === "Resources"
          ? styles.reSources
          : styles.home
      )}
    >
      <div className={styles.left}>
        <p
          className={classNames(
            styles.topText,
            title === "Bridging Loans"
              ? styles.bLoans
              : title === "Development Finance"
              ? styles.dFinance
              : title === "Stop Repossessions"
              ? styles.sRepo
              : title === "Resources"
              ? styles.reSources
              : styles.home
          )}
        >
          Breaking News
        </p>
        <p className={styles.midText}>
          {title === "Bridging Loans"
            ? "LOWEST EVER BRIDGING RATES"
            : title === "Development Finance"
            ? "LOWEST EVER DEVELOPMENT FINANCE RATES"
            : title === "Stop Repossessions"
            ? "OUR FASTEST 24hr BRIDGE COMPLETED "
            : title === "Re-Bridging Finance"
            ? "LOWEST EVER RE-BRIDGING RATES"
            : title === "Resources"
            ? "LOWEST EVER RE-BRIDGING RATES"
            : "LOWEST EVER RE-BRIDGING RATES - 0.65% per Month"}
        </p>
        <p className={styles.bottomText}>
          {title === "Bridging Loans"
            ? "WE HAVE ACCESS TO A NEW FUNDING LINE ALLOWING US TO OFFER A RATE 0F 0.35% PER MONTH ON A RE-BRIDGE"
            : title === "Development Finance"
            ? "WE HAVE ACCESS TO A NEW FUNDING LINE ALLOWING US TO OFFER A RATE of 4.8 pa for experienced developers"
            : title === "Stop Repossessions"
            ? "RATE APPLIED WAS 1% PER MONTH WIHT A LTV OF 85% SAVING THE CLIENT 6% IN DEFAULT PENALTIES.TRY US NOW AND APPLY HERE"
            : title === "Re-Bridging Finance"
            ? "WE HAVE ACCESS TO A NEW FUNDING LINE ALLOWING US TO OFFER A RATE 0F 0.65% PER MONTH ON A RE-BRIDGE"
            : title === "Resources"
            ? "LOWEST EVER RE-BRIDGING RATES"
            : "WE HAVE ACCESS TO A NEW FUNDING LINE ALLOWING US TO OFFER A RATE 0F 0.65% PER MONTH ON A RE-BRIDGE"}
        </p>
      </div>
      <Link
        to="/bridgingloans/guide"
        className={classNames(
          styles.link,
          title === "Bridging Loans"
            ? styles.bLoans
            : title === "Development Finance"
            ? styles.dFinance
            : title === "Stop Repossessions"
            ? styles.sRepo
            : title === "Resources"
            ? styles.reSources
            : styles.home
        )}
      >
        Learn More
      </Link>
    </div>
  );
};

export default NewsContainer;
